import React, { useEffect, useRef } from 'react';

import { useHubspotEmbed } from '../HubSpot/HubSpotEmbed';
import { useSettings } from '../../providers/Settings/SettingsProvider';
import './styles.css';

export const FormScreen = () => {
  const ref = useRef(null);

  const {initForm} = useHubspotEmbed();

  const {
    hubspotPortalId,
    hubspotFormId
  } = useSettings();

  useEffect(() => {
    if (ref.current) {
      initForm(hubspotPortalId, hubspotFormId, '#hubspot-form');
    }
  }, [initForm, ref, hubspotPortalId, hubspotFormId]);

  return (
    <div className='container mx-auto max-w-sm'>
      <div className="FormScreen h-screen w-full bg-background overflow-hidden relative">

        <h1 className="text-2xl font-bold text-primary my-6 text-center">ENTER TO WIN</h1>

        <div className="w-full max-w-md p-4">
          <div className="w-full max-w-md p-4 bg-white rounded-lg shadow-md">
            <div ref={ref} id='hubspot-form' className="hubspot-form" />
          </div>
        </div>

      </div>
    </div>
  );
}